import { createAction, props } from '@ngrx/store';

export const viewToast = createAction(
  '[Common] View Toast',
  props<{ message: string }>()
);

export const clearToast = createAction('[Common] Clear Toast');
